import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { TOOL_CATEGORIES, type ToolCategory } from '@/services/tools'

interface ToolCategoryFilterProps {
  selectedCategory: string | null
  onCategoryChange: (category: string | null) => void
}

export function ToolCategoryFilter({
  selectedCategory,
  onCategoryChange,
}: ToolCategoryFilterProps) {
  const { t } = useTranslation('tools')

  const categories: Array<{ value: string | null; label: string }> = [
    { value: null, label: t('categories.all') },
    ...TOOL_CATEGORIES.map((cat: ToolCategory) => ({
      value: cat,
      label: t(`categories.${cat}`),
    })),
  ]

  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <button
          key={cat.value ?? 'all'}
          onClick={() => onCategoryChange(cat.value)}
          className={cn(
            'px-3 py-1.5 text-sm rounded-lg transition-all duration-200',
            selectedCategory === cat.value
              ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/30'
              : 'bg-white/5 text-gray-400 border border-gray-700/50 hover:bg-white/10 hover:text-white'
          )}
        >
          {cat.label}
        </button>
      ))}
    </div>
  )
}
